<template>
    <MaltImg
        v-if="imageUrl"
        provider="prismic"
        :src="imageUrl"
        :alt="imageAlt ?? imageUrl"
        :sizes="sizes"
        :height="height"
        :width="width"
        :quality="quality"
        :loading="loading ?? 'lazy'"
    />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {ImageField} from '@prismicio/types';
    import {MaltImg} from '#components';

    const props = defineProps<{
        imageField: ImageField;
        width?: number | string;
        height?: number | string;
        quality?: number | string;
        loading?: 'lazy' | 'eager';
        sizes?: string;
    }>();

    const imageUrl = computed(() => props.imageField.url);
    const imageAlt = computed(() => props.imageField.alt);
</script>
